export const useStyles = (theme) => ({
  root: {
    padding: 10,
  },
  tooltip: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  selectRoot: {
    backgroundColor: "#fff !important",
    paddingTop: 0,
    paddingBottom: 0,
  },
  inputRoot: {
    height: 40,
  },
  notchedOutline: {},
  focused: {
    "& $notchedOutline": {
      borderColor: "#181818 !important",
    },
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bold",
    backgroundColor: "#eee",
    paddingRight: 5,
  },
  labelFocused: { color: "#181818 !important" },

  buttonStyle: {
    backgroundColor: "#004f70 !important",
    borderRadius: 20,
    color: "#fff",
    fontSize: 16,
    fontWeight: "bold",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#004f70 !important",
      color: "#000",
    },
  },
});
